// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1SI9M","alertIcon":"ConfirmModal_alertIcon__18WiP"};